// Frontend mirror of functions/_lib/cashflow.ts — the Movement_Type → cash-flow
// class mapping, plus display labels/colors for the Operating / Financing /
// Investing breakdown. Keep the FINANCING_TYPES set in sync with the backend.
import { CHART } from "./chart";
import type { CashFlowClass } from "@shared/types";

export const FINANCING_TYPES = new Set<string>([
  "Bank Draw",
  "Investor Contribution",
  "Interest expense / Loan Fees",
  "Principal",
  "Investor Distribution",
]);

// Everything that isn't a financing movement (notably "Expense") is Operating.
// No movement maps to Investing today, so it stays $0 until such movements exist.
export function classifyMovement(lineType: string | null | undefined): CashFlowClass {
  return lineType && FINANCING_TYPES.has(lineType) ? "financing" : "operating";
}

export const CLASS_LABEL: Record<CashFlowClass, string> = {
  operating: "Operating",
  financing: "Financing",
  investing: "Investing",
};

export const CLASS_COLOR: Record<CashFlowClass, string> = {
  operating: CHART.accent,
  financing: CHART.purple,
  investing: CHART.axis,
};
